var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "cruise-info" }, [
    _c(
      "div",
      { staticClass: "cruise-info__main" },
      [
        _c(_setup.MySlider, {
          staticClass: "cruise-info__slider",
          attrs: {
            slideRatio: 190 / 280,
            slides: _setup.headPhotos,
            srcKey: "src_next",
            idKey: "id",
          },
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "cruise-info__content" },
          [
            _c(
              "router-link",
              {
                staticClass: "cruise-info__title",
                attrs: { to: _setup.cruise_link, target: "_blank" },
              },
              [_vm._v(_vm._s(_setup.beautifulName))]
            ),
            _vm._v(" "),
            _c(_setup.CruiseDates, { attrs: { dates: _setup.dates } }),
            _vm._v(" "),
            _c(_setup.ShipHead, { attrs: { ship: _setup.shipHead } }),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "cruise-info__route" }, [
          _c("div", { staticClass: "cruise-info__route-title" }, [
            _vm._v("Полный маршрут:"),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "cruise-info__route-cities" }, [
            _vm._v(_vm._s(_setup.routeFormatted)),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "cruise-info__sku-ids" }, [
          _vm._v(
            _vm._s(_setup.cruiseIdString) +
              " проверено " +
              _vm._s(_setup.checkedH)
          ),
        ]),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "cruise-info__booking" },
      [
        _c(
          "div",
          { staticClass: "cruise-info__price-min" },
          [
            _setup.min_price.is
              ? [
                  _vm._v("от "),
                  _c(_setup.PriceCurrencyV, {
                    attrs: { price: _setup.min_price, sum: true },
                  }),
                ]
              : _vm._e(),
          ],
          2
        ),
        _vm._v(" "),
        _setup.isKlk
          ? _c(
              "div",
              { staticClass: "klkmark" },
              [
                _c(_setup.KlkIcon, { staticClass: "kicon vicon-grey" }),
                _vm._v("Возможна оплата баллами"),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "cruise-info__available" }, [
          _c(
            "div",
            { staticClass: "cruise-info__suggestion" },
            [
              _setup.freeCabins
                ? [
                    _setup.hideFree(_setup.shipId)
                      ? [_vm._v("Свободные каюты есть")]
                      : [
                          _vm._v(
                            _vm._s(_setup.HaveLeftCabin(_setup.freeCabins))
                          ),
                        ],
                  ]
                : [
                    _vm._v(
                      "\n                    Свободных кают нет\n                "
                    ),
                  ],
            ],
            2
          ),
          _vm._v(" "),
          _setup.min_price.is
            ? _c("div", { staticClass: "cruise-info__option" }, [
                _c("div", { staticClass: "cruise-info__option-name" }, [
                  _vm._v("за человека"),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "cruise-info__option-price" },
                  [
                    _vm._v("\n                    от "),
                    _c(_setup.PriceCurrencyV, {
                      attrs: { price: _setup.min_price, sum: true },
                    }),
                  ],
                  1
                ),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c(
          "router-link",
          {
            staticClass: "btn btn--bluefigma",
            attrs: { to: _setup.cruise_link, target: "_blank" },
          },
          [_vm._v("\n            Выбрать каюту\n        ")]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }